import React from 'react';
import { ColorsV2 } from 'app/constants/color';
import Chart from '@energiency/chartjs-plugin-piechart-outlabels';
import NoData from 'app/pages/insights/compliance/NoData';
import { checkForAssignedChartColor } from 'app/utils';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Pie } from 'react-chartjs-2';
import { useSelector } from 'react-redux';

const PieChart = ({ setClicked, clicked, type, chartData }) => {
  const newArr =
    chartData?.length &&
    [...chartData].sort((a, b) => {
      const idA = parseInt(a.id?.slice(1), 10);
      const idB = parseInt(b.id?.slice(1), 10);
      return idA - idB;
    });

    const chartColors = useSelector(state => state?.userSettings?.settings?.chartColors) || {};
  
    const getColor = id => {
      return chartColors[id] || checkForAssignedChartColor(id);
    };

  const spreadValues = newArr?.length > 0 ? newArr?.map(obj => obj.spread) : [];

  const labelValues = newArr?.length > 0 ? newArr?.map(obj => obj.name) : [];

  const idValues = newArr?.length > 0 ? newArr?.map(obj => obj.id) : [];

  const Color_values = labelValues?.map((label, index) =>
    clicked.length === 0 || clicked.includes(labelValues[index])
      ? getColor(idValues[index])
      : '#e5fffa'
  );

  const data = {
    labels: [...labelValues],
    datasets: [
      {
        label: '# of Votes',
        data: [...spreadValues],
        backgroundColor: [...Color_values],
        offset: 20,
        hoverOffset: 35,
      },
    ],
  };

  const handleClick = (event, elements) => {
    if (elements?.length) {
      const clickedLabel = data.labels[elements[0].index];
      setClicked(prevClicked => {
        if (prevClicked.includes(clickedLabel)) {
          return prevClicked.filter(item => item !== clickedLabel);
        } else {
          return [...prevClicked, clickedLabel];
        }
      });
    }
  };

  const options = {
    onClick: type !== 'global' && handleClick,
    layout: {
      padding: {
        top: 15,
        bottom: 15,
      },
    },
    elements: {
      arc: {
        borderWidth: 1,
      },
    },
    maintainAspectRatio: false,

    plugins: {
      align: 'end',
      datalabels: {
        display: false,
        color: 'white',
        formatter(value) {
          if (value > 3) {
            return `${Math.round(value)}%`;
          } else {
            return '';
          }
        },
        font: {
          weight: '700',
          size: '20px',
          style: 'normal',
          family: 'Inter',
        },
        offset: type === 'global' ? -100 : -180,
        textStrokeColor: '#333',
        textAlign: 'center',
        anchor: 'start', // Set anchor to 'end'
        align: 'start',
      },
      outlabels: {
        display: false,
        text(context) {
          const value = context.dataset.data[context.dataIndex];
          return value < 3 ? '' : value > 3 ? '%l' : '%l - %v%';
        },
        color: ColorsV2.white,
        stretch(context) {
          const label = context.dataset.data[context.dataIndex];
          return label < 1 ? 0 : 35;
        },
        font: {
          size: 11,
          weight: 'normal',
          lineHeight: 5,
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label(context) {
            const label = context.label;
            const value = context.parsed;
            if (value > 3) {
              return `${label}: ${value.toFixed(1)}%`;
            } else {
              return '';
            }
          },
        },
      },
    },
    animation: false,
  };
  const plugins = [ChartDataLabels, Chart];

  if (!chartData) {
    return <NoData />;
  }

  return <Pie data={data} options={options} plugins={plugins} />;
};

export default React.memo(PieChart);
